<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex al-center">
          <div class="d-flex al-center text-left">
            <el-select
              class="select-period"
              v-model="mData.currentViewPeriod"
              @change="changePeriod"
              placeholder="Kỳ lương"
            >
              <el-option
                v-for="item in mData.dataDefault.listSalaryPeriods"
                :key="item.id"
                :label="item.name_period"
                :value="item.id">
              </el-option>
            </el-select>
            <h5 class="ml-3">
              <a
                href="/admin/income-information"
                @click="goToEmployeeIncome"
              >Thông tin thu nhập</a>
            </h5>
          </div>
          <div class="text-right">
            <p>
              Update gần nhất:
              <span
                :class="
                  mData.timeGetData == 'Chưa có dữ liệu chấm công!'
                    ? 'time-update c-orange'
                    : (new Date().getTime() - new Date(mData.timeGetData).getTime()) /
                        60000 <=
                      15
                    ? 'time-update c-green'
                    : 15 <
                        (new Date().getTime() - new Date(mData.timeGetData).getTime()) /
                          60000 &&
                      (new Date().getTime() - new Date(mData.timeGetData).getTime()) /
                        60000 <=
                        30
                    ? 'time-update c-orange'
                    : 'time-update c-red'
                "
              >
                {{
                  mData.timeGetData == "Chưa có dữ liệu chấm công!"
                    ? mData.timeGetData
                    : formatDateTime(mData.timeGetData)
                }}
              </span>
            </p>
          </div>
        </div>
        <div class="main-body mt-3">
          <div class="detail-infomation">
            <div class="detail-infomation__block work-data">
              <div class="data">
                <span>
                  <countTo
                    :startVal="mData.countConfig.startVal"
                    :endVal="mData.totalWork"
                    :duration="mData.countConfig.timeDuration"
                    :decimals="1"
                  ></countTo>
                  /
                  <countTo
                    :startVal="mData.countConfig.startVal"
                    :endVal="mData.totalWorkCorrect"
                    :duration="mData.countConfig.timeDuration"
                    :decimals="1"
                  ></countTo>
                </span>
                <div class="icon">
                  <i class="icon24-Profile"></i>
                </div>
              </div>
              <div class="title">
                <p>Công thực tế / Công chuẩn</p>
                <p>(Tính đến ngày hiện tại)</p>
              </div>
            </div>
            <div class="detail-infomation__block work-error">
              <div class="data">
                <span>
                  <countTo
                    :startVal="mData.countConfig.startVal"
                    :endVal="mData.numberOfWorkErrors"
                    :duration="mData.countConfig.timeDuration"
                    :decimals="1"
                  ></countTo>
                </span>
                <div class="icon">
                  <i class="isax-tick-circle"></i>
                </div>
              </div>
              <div class="title">
                <p>Lỗi ngày công</p>
                <p>(Tính đến ngày hiện tại)</p>
              </div>
            </div>
           <!-- Công việc chưa hoàn thành -->
            <div class="detail-infomation__block ontime">
                  <div class="data">
                    <span>
                      <countTo
                        :startVal="mData.countConfig.startVal"
                        :endVal="mData.workStats.uncompletedCount"
                        :duration="mData.countConfig.timeDuration"
                        :decimals="0"
                      ></countTo>
                    </span>
                    <div class="icon">
                     <i class="icon24-QuanLyCongViec"></i>
                    </div>
                  </div>
                  <div class="title">
                    <p>Công việc chưa hoàn thành</p>

                  </div>
            </div>

           
            <div class="detail-infomation__block go-late">
              <div class="data">
                <span>
                  <countTo
                    :startVal="mData.countConfig.startVal"
                    :endVal="mData.countGoLate"
                    :duration="mData.countConfig.timeDuration"
                    :decimals="1"
                  ></countTo>
                </span>
                <div class="icon">
                  <i class="icon24-LichSu"></i>
                </div>
              </div>
              <div class="title">
                <p>Số lần đi muộn, về sớm</p>
                <p>(Trong kỳ)</p>
              </div>
            </div>
            <div class="detail-infomation__block day-off">
              <div class="data">
                <span>
                  <countTo
                    :startVal="mData.countConfig.startVal"
                    :endVal="mData.countDayOff"
                    :duration="mData.countConfig.timeDuration"
                    :decimals="1"
                  ></countTo>
                </span>
                <!-- <p class="doing">Đang phát triển</p> -->
                <div class="icon">
                  <i class="icon24-VB_DaChoYKien"></i>
                </div>
              </div>
              <div class="title">
                <p>Số ngày đã nghỉ phép</p>
                <p>(Trong kỳ)</p>
              </div>
            </div>
          </div>
          <div class="body-container">
            <div class="block-left">
              <div class="block__chart block__chart--work">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="title">Biểu đồ ngày công</span>
                    <a
                      href="javascipt:0"
                      style="float: right; padding: 3px 0"
                      v-b-toggle.accordion-1
                      class="toggle--action"
                    >
                      {{ mData.showWorkDayChart ? 'Thu gọn' : 'Mở rộng' }}
                    </a>
                  </div>
                  <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                    <b-card-body>
                      <div class="chart">
                        <EChart
                          :optionChart="mData.optionChartWorkDay"
                          :heightChart="'320'"
                          :chartId="'ChartWorkDay'"
                          :newData="newDataProp"
                        />
                      </div>
                      <div class="detail-data">
                        <p class="main-title">Công chuẩn trong kỳ: {{mData.standardWorkInPeriod}}</p>
                        <p class="sub-title"><span class="dot dot--enough" /> Số công đủ ({{mData.amountOfWorkEnough}})</p>
                        <p class="sub-title"><span class="dot dot--error" /> Số công lỗi ({{mData.numberOfWorkErrors}})</p>
                        <p class="sub-title"><span class="dot dot--remaning" /> Số công còn lại ({{mData.remainingAmountOfWork}})</p>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </el-card>
              </div>
              <div class="block__chart block__chart--detailed">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="title">Biểu đồ chi tiết trong kỳ</span>
                    <a
                      href="javascipt:0"
                      style="float: right; padding: 3px 0"
                      v-b-toggle.accordion-2
                      class="toggle--action"
                    >
                      {{ mData.showDetailChart ? 'Thu gọn' : 'Mở rộng' }}
                    </a>
                  </div>
                  <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                    <b-card-body>
                      <div class="chart">
                        <EChart
                          :optionChart="mData.optionChartDetailed"
                          :heightChart="'320'"
                          :chartId="'ChartDetailed'"
                          :newData="newDataProp"
                        />
                      </div>
                      <div class="detail-data">
                        <p class="main-title">Tổng ngày công hiện tại: {{mData.totalCurrentWorkingDay}}</p>
                        <p class="sub-title"><span class="dot dot--golate" /> Đi muộn, về sớm ({{mData.countGoLate}})</p>
                        <p class="sub-title"><span class="dot dot--dayoff" /> Nghỉ phép ({{mData.countDayOff}})</p>
                        <p class="sub-title"><span class="dot dot--ontime" /> Đúng giờ ({{mData.countOnTime}})</p>
                        <p class="sub-title"><span class="dot dot--others" /> Khác ({{mData.orthers}})</p>
                      </div>
                    </b-card-body>
                    <!-- <b-card-body style="min-height: 340px;" class="doing--card">
                      <p>Đang phát triển</p>
                    </b-card-body> -->
                  </b-collapse>
                </el-card>
              </div>
              <div class="block__request">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="title">Danh sách yêu cầu</span>
                    <a
                      :underline="false"
                      href="/admin/personal-request"
                      @click="goToListRequest"
                      style="float: right; padding: 3px 0"
                      class="toggle--action"
                    >
                      Xem chi tiết
                    </a>
                  </div>
                  <Request
                    :time="new Date()"
                  />
                </el-card>
              </div>
            </div>
            <div class="block__aside">
              <div class="block-calendar">
                <el-card class="box-card card--calendar">
                  <div slot="header" class="clearfix">
                    <span class="title">Lịch tháng</span>
                    <a
                      href="javascipt:0"
                      style="float: right; padding: 3px 0"
                      v-b-toggle.calendar
                      class="toggle--action"
                    >
                      {{ mData.showDCalendar ? 'Thu gọn' : 'Mở rộng' }}
                    </a>
                  </div>
                  <b-collapse id="calendar" visible accordion="my-calendar" role="tabpanel">
                    <b-card-body>
                      <Calendar></Calendar>
                    </b-card-body>
                  </b-collapse>
                </el-card>
              </div>
              <div
                :class="{
                  'noti--list': true,
                  'collapse-calendar': !mData.showDCalendar
                }">
                <p class="title">Thông báo hệ thống</p>
                <Notification class="noti--list__component"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import MethodService from '@/service/MethodService'
import DashboardModel from './DashboardModel'
import EmployeeRequestApi from '@/moduleApi/EmployeeRequestApi'
import TimeKeepingRawCurrentLogApi from '@/moduleApi/TimeKeepingRawCurrentLogApi'
import EmployeeShiftApi from '@/moduleApi/EmployeeShiftApi'
import EmployeeApi from '@/moduleApi/EmployeeApi'
import ShiftApi from '@/moduleApi/ShiftApi'
import SalaryPeriodApi from '@/moduleApi/SalaryPeriodApi'
import SalaryApi from '@/moduleApi/SalaryApi'
import WorkApi from '@/moduleApi/WorkApi'
import TimeKeepingLogApi from '@/moduleApi/TimeKeepingLogApi'
import HeaderCalendar from './HeaderCalendar'
import Calendar from '@/component/Calendar'
import EChart from '@/component/EChart/EChart'
import Request from './components/Request'
import Notification from './components/Notification'
import Loading from '@/component/Loading'
import { Filter } from 'mushroomjs'
import UserApi from '@/moduleApi/UserApi'
export default {
  components: {
    countTo,
    HeaderCalendar,
    Calendar,
    EChart,
    Request,
    Notification,
    Loading,
  },
  data() {
    return {
      date: new Date(),
      loading: true,
      newDataProp: false,
      callPromise: null,
      mData: {
         workStats: {
        uncompletedCount: 0
        },
        currentViewPeriod: undefined,
        totalWork: 0,
        totalWorkCorrect: 0,
        standardWorkInPeriod: 0,
        numberOfWorkErrors: 0,
        amountOfWorkEnough: 0,
        remainingAmountOfWork: 0,
        totalCurrentWorkingDay: 0,
        showWorkDayChart: true,
        showDetailChart: true,
        showDCalendar: true,
        countOnTime: 0,
        countGoLate: 0,
        countDayOff: 0,
        orthers: 0,
        timeGetData: '',
        dayMonthYear: '',
        month: undefined,
        year: undefined,
        monthlyPeriod: new Date(),
        firstDayInMonth: undefined,
        lastDayInMonth:  undefined,
        beforeToDate: undefined,
        currentUser: MethodService.getCurrentUser(),
        employeeInfo: MethodService.getEmployeeInfo(),
        listFeature: MethodService.getListFeatures(),
        optionChartWorkDay: DashboardModel.optionChartWorkDay,
        optionChartDetailed: DashboardModel.optionChartDetailed,
        countConfig: {
          startVal: 0,
          timeDuration: 2500,
        },
        dataDefault: {
          employeeShifts: [],
          listEmployee: [],
          listSalaryPeriods: [],
          salaryPeriod: undefined,
        },
      },
    }
  },
  methods: {
    goToListRequest(e) {
      this.$router.push({
        name: 'Admin-Personal-Request'
      }).catch(() => {})
      e.preventDefault()
    },
    goToEmployeeIncome(e) {
      this.$router.push({
        name: 'Admin-Income-Information'
      }).catch(() => {})
      if (!e) return
      e.preventDefault()
    },
    // Getting the latest time of the data.
    async fn_initDataDefault() {
      const runTimeReq = TimeKeepingRawCurrentLogApi.list({
        limit: 1,
        sort: '-created_at',
      })
      const salaryApiReq = SalaryApi.list({
        filters: `employee_id=$$user_id`,
        fields: 'salary_period_id',
        limit: 1000
      })
      const salaryPeriodReq = SalaryPeriodApi.list({
        limit: 10000,
        fields: 'from_date,before_to_date',
        sort: '-id',
      })
      const runTimeRes = await runTimeReq
      const salaryApiRes = await salaryApiReq
      const salaryPeriodRes = await salaryPeriodReq
      if (runTimeRes && runTimeRes.result.length > 0 && runTimeRes.result[0].created_at) {
        this.mData.timeGetData = runTimeRes.result[0].created_at
      } else {
        this.mData.timeGetData = 'Chưa có dữ liệu chấm công!'
      }
      let arrSalaryPeriodIds = MethodService.findListItemDifferent(salaryApiRes.result, 'salary_period_id')
      this.mData.dataDefault.listSalaryPeriods = this.changeDataSalaryPeriod(salaryPeriodRes.result)
      if (!this.mData.currentViewPeriod) {
        this.mData.currentViewPeriod = this.mData.dataDefault.listSalaryPeriods.length > 0 ? this.mData.dataDefault.listSalaryPeriods[0].id : undefined
      }
      this.setFromToDate(this.mData.currentViewPeriod)
      this.getListSalaryPeriodByIds(arrSalaryPeriodIds)
      this.changeRoute()
    },
    changeDataSalaryPeriod(data) {
      data.forEach(item => item.name_period = this.changeNameSalaryPeriodToMMYYYY(item.from_date))
      return data
    },
    // A function to change the name of the period to the format MM/YYYY.
    changeNameSalaryPeriodToMMYYYY(date) {
      let month = new Date(date).getMonth() + 1
      let year = new Date(date).getFullYear()
      return `Kỳ tháng ${month}/${year}`
    },

    // This function is used to initialize data.
    fn_initData() {
      if (this.callPromise) return this.callPromise
      this.callPromise = (async () => {
        this.newDataProp = false
        await this.fn_initDataDefault()
        await this.calcPeriodDetailOfEmployee()
        await this.fn_getEmployeeShift()
        await this.fn_getUncompletedWorks()
        window.setTimeoutEmployee = setTimeout(() => {
          this.refreshData()
        }, 1000 * 300) //5 phút
      })().finally(() => {
        this.callPromise = null
      })
      return this.callPromise
    },
    async changePeriod() {
      this.newDataProp = false
      this.mData.dataDefault.salaryPeriod = this.mData.dataDefault.listSalaryPeriods.find(item => item.id == this.mData.currentViewPeriod)
      this.mData.monthlyPeriod = new Date(this.mData.dataDefault.salaryPeriod.from_date)
      this.resetData5Block()
      this.setFromToDate(this.mData.currentViewPeriod)
      await this.calcPeriodDetailOfEmployee()
      await this.fn_getEmployeeShift()
      this.changeRoute()
    },
    async calcPeriodDetailOfEmployee() {
      const resApi = await EmployeeApi.CalcPeriodDetailOfEmployee({
        salary_period_id: this.mData.currentViewPeriod,
      })
      this.mData.countGoLate = resApi.result.numberOfGoLateAndGoHomeEarlys
      this.mData.countOnTime = resApi.result.numberOnWork
      this.mData.amountOfWorkEnough = resApi.result.numberEnoughWorks
      this.mData.countDayOff = resApi.result.numberOfDayOffs
      this.mData.totalCurrentWorkingDay = resApi.result.totalWorks
      this.mData.numberOfWorkErrors = resApi.result.numberErrorWorks
      this.mData.orthers = resApi.result.numberOthers
      this.newDataProp = true
      this.mData.optionChartDetailed.series[0].data = [
        { value: this.mData.countGoLate, name: 'Đi muộn, về sớm' },
        { value: this.mData.countDayOff, name: 'Nghỉ phép' },
        { value: this.mData.countOnTime, name: 'Đúng giờ' },
        { value: this.mData.orthers, name: 'Khác' },
      ]    
    },
    changeRoute() {
      this.$router.replace({
        name: 'Admin-Individual-Dashboard',
        query: {
          s: this.mData.currentViewPeriod
        }
      }).catch(() => {})
    },
    // Getting the employee shift of the current user.
    async fn_getEmployeeShift() {
      let filter = Filter.and(
        Filter.eq('employee_id', '$$user_id'),
        Filter.lte('start_time', this.mData.lastDayInMonth),
        Filter.or(
          Filter.isNull('end_time'),
          Filter.gte('end_time', this.mData.firstDayInMonth)
        )
      ).build()
      const employeeShift = await EmployeeShiftApi.list({
        filters: filter
      })
      const employeeAllShift = await EmployeeShiftApi.list({
        limit: 100
      })
      if (employeeShift.result && employeeShift.result.length > 0) {
        this.mData.dataDefault.employeeShifts = employeeShift.result
        let arrShiftIds = MethodService.findListItemDifferent(employeeShift.result, 'shift_id')
        this.getDataShift(arrShiftIds)
        this.getStandardWork(this.mData.dataDefault.employeeShifts)
      }
      if (employeeAllShift.result && employeeAllShift.result.length > 0) {
        let arrStartTimes = MethodService.findListItemDifferent(employeeAllShift.result, 'start_time')
      }
    },

   // Getting the get Uncompleted Works of the current user.
  async fn_getUncompletedWorks() {

    const [todayRes, backlogRes] = await Promise.all([
      UserApi.GetMyTodayTask({}),
      UserApi.GetMyBackLog({})
    ])

  const todayTasks = (todayRes && todayRes.result && todayRes.result.tasks) ? todayRes.result.tasks : []
  const backlogTasks = (backlogRes && backlogRes.result && backlogRes.result.tasks) ? backlogRes.result.tasks : []

  const allTasks = [...todayTasks, ...backlogTasks]

  const uncompletedTasks = allTasks.filter(task =>
      task.status === 'NOT_STARTED' || task.status === 'IN_PROGRESS'
    );
  this.mData.workStats = {
    uncompletedCount: uncompletedTasks.length
  }
},

    // Getting the list of shifts from the API by ids.
    async getDataShift(arrShiftIds) {
      const resShiftApi = await ShiftApi.list({
        filters: `id:in:${arrShiftIds.join(',')}`,
        limit: arrShiftIds.length
      })
      this.mData.dataDefault.listShifts = resShiftApi.result
    },

    // Getting the standard work for each shift id in the array.
    getStandardWork(arrShift) {
      this.resetData5Block()
      this.mData.standardWorkInPeriod = 0
      this.mData.totalWorkCorrect = 0
      let promises = []
      arrShift.forEach(item => {
        promises.push(
          ShiftApi.CalcStandardWork({
            shiftId: item.shift_id,
            formDate: new Date(item.start_time).getTime() > new Date(MethodService.getFirstDayOfMonth(this.mData.monthlyPeriod)).getTime()
                        ? item.start_time
                        : MethodService.getFirstDayOfMonth(this.mData.monthlyPeriod),
            toDate: !item.end_time || new Date(item.end_time).getTime() > new Date(MethodService.getLastDayOfMonth(this.mData.monthlyPeriod)).getTime()
                    ? MethodService.getLastDayOfMonth(this.mData.monthlyPeriod)
                    : item.end_time,
          })
        )
      })
      Promise.all(promises).then(res => {
        res.forEach(e => {
          this.mData.totalWorkCorrect += e.result.standardWork
          this.mData.standardWorkInPeriod += e.result.workCount
        })
        this.getSalaryPeriod()
      }).catch(err => {})
    },

    // Getting the salary period for the month selected.
    async getSalaryPeriod() {
      const salaryperiodApiRes = await SalaryPeriodApi.list({
        filters:
          "from_date<=" + new Date(MethodService.getFirstDayOfMonth(this.mData.monthlyPeriod)).toISOString() +
          "&before_to_date>=" + new Date(MethodService.getLastDayOfMonth(this.mData.monthlyPeriod)).toISOString(),
      })
      if (salaryperiodApiRes.result && salaryperiodApiRes.result.length > 0) {
        if (!this.mData.dataDefault.salaryPeriod) this.mData.dataDefault.salaryPeriod = salaryperiodApiRes.result[0]
        this.getAllWork()
      }
    },

    async getListSalaryPeriodByIds(arrSalaryPeriodIds) {
      const salaryperiodByIdsApiRes = await SalaryPeriodApi.list({
        filters: `id:in:${arrSalaryPeriodIds.join(',')}`,
        limit: arrSalaryPeriodIds.length,
        fields: 'from_date',
        sort: '-id'
      })
      salaryperiodByIdsApiRes.result.forEach(period => {

      })
    },

    // Calling the WorkApi.list method and passing in the following parameters:
    // - limit: 9999999
    // - filters:
    // `employee_id=${this.mData.currentUser.id}&salary_period_id=${this.mData.dataDefault.salaryPeriod.id}`
    // The above code is a function that is used to get the data of the employee's work in the current
    // period.
    async getAllWork() {
      this.resetData5Block()
      const workApiRes = await WorkApi.list({
        limit: 9999999,
        filters: `employee_id=${this.mData.currentUser.id}&salary_period_id=${this.mData.dataDefault.salaryPeriod.id}`,
      })
      workApiRes.result.forEach(item => {
        this.mData.totalWork += item.work_value
      })
      this.mData.remainingAmountOfWork = this.mData.standardWorkInPeriod - (this.mData.numberOfWorkErrors + this.mData.amountOfWorkEnough)
      if (this.mData.remainingAmountOfWork < 0) this.mData.remainingAmountOfWork = 0
      this.mData.optionChartWorkDay.series[0].data = [
        { value: this.mData.amountOfWorkEnough, name: 'Công đủ' },
        { value: this.mData.numberOfWorkErrors, name: 'Lỗi ngày công' },
        { value: this.mData.remainingAmountOfWork, name: 'Số ngày còn lại' },
      ]
      this.newDataProp = true
    },

    // Checking if the employee is on time or not.
    fn_checkOnTime(day, time) {
      let check = true
      let dayShift = (day + 1).toString()
      let firstTimeLog = time
      let timeCheck = new Date(time)
      if (this.mData.dataDefault.listShifts.length > 0) {
        this.mData.dataDefault.listShifts.forEach((e) => {
          let workDay = {}
          let firstTimeOfShift = ""
          if (e.work_days && e.work_days.length > 0) {
            workDay = e.work_days.find((x) => {
              return (
                ((x.period_time &&
                  x.period_time[0] &&
                  x.period_time[0].start_time &&
                  x.period_time[0].start_time.hour) ||
                  (x.period_time &&
                    x.period_time[0] &&
                    x.period_time[0].start_time &&
                    !x.period_time[0].start_time.hour &&
                    x.period_time &&
                    x.period_time[1] &&
                    x.period_time[1].start_time &&
                    x.period_time[1].start_time.hour)) &&
                x.name == dayShift
              )
            })
          }
          if (workDay != undefined) {
            if (
              workDay.period_time &&
              workDay.period_time[0] &&
              workDay.period_time[0].start_time &&
              workDay.period_time[0].start_time.hour
            ) {
              firstTimeOfShift = new Date(
                timeCheck.getFullYear(),
                timeCheck.getMonth(),
                timeCheck.getDate(),
                workDay.period_time[0].start_time.hour,
                workDay.period_time[0].start_time.minute
              )
            } else {
              firstTimeOfShift = new Date(
                timeCheck.getFullYear(),
                timeCheck.getMonth(),
                timeCheck.getDate(),
                workDay.period_time[1].start_time.hour,
                workDay.period_time[1].start_time.minute
              )
            }
            //Nếu thời gian check in lớn hơn giờ bắt đầu của ca thì đi muộn và ngược lại
            if (new Date(firstTimeLog).getTime() > new Date(firstTimeOfShift).getTime()) {
              check = false
              return
            }
          }
        })
      } else {
        check = false
      }
      return check
    },

    fn_getFirstTimeLog(employeeId, time, arrCheckIns) {
      let timeKeepingLog = arrCheckIns.filter((item) => {
        return (
          item.employee_id == employeeId &&
          new Date(item.time).getFullYear() == new Date(time).getFullYear() &&
          new Date(item.time).getMonth() == new Date(time).getMonth() &&
          new Date(item.time).getDate() == new Date(time).getDate()
        )
      })
      timeKeepingLog = timeKeepingLog.sort(function (a, b) {
        return new Date(a.time).getTime() - new Date(b.time).getTime()
      })
      return timeKeepingLog[0]
    },

    // Resetting the data in the Vue HTML.
    resetData5Block() {
      this.mData.totalWork = 0
      // this.mData.amountOfWorkEnough = 0
    },

   // A method that is being called in the template.
    formatDate(value) {
      return MethodService.formatDate(value, 'date')
    },

    // A method that is being called in the Vue HTML.
    formatDateTime(value) {
      return MethodService.formatDate(value, 'timedate')
    },
    fn_hashUrl() {
      if (this.$route.query.s) {
        this.mData.currentViewPeriod = this.$route.query.s
      }
    },
    getDateFromPeriod(periodId) {
      let period = this.mData.dataDefault.listSalaryPeriods.find(e => e.id == periodId)
      return {
        fromDate: new Date(period.from_date),
        toDate: new Date(period.before_to_date)
      }
    },
    setFromToDate(periodId) {
      this.mData.firstDayInMonth = new Date(MethodService.getFirstDayOfMonth(this.getDateFromPeriod(periodId).fromDate)).toISOString()
      this.mData.lastDayInMonth = new Date(MethodService.getLastDayOfMonth(this.getDateFromPeriod(periodId).fromDate)).toISOString()
      this.mData.beforeToDate = new Date(this.getDateFromPeriod(periodId).fromDate).toISOString()
      this.mData.monthlyPeriod = new Date(this.getDateFromPeriod(periodId).fromDate)
    },

    // A function that will be called every 5 minutes to update the data.
    async refreshData() {
      this.newDataProp = false
      this.fn_initData()
    },
  },
  // This is a function that will be called when the component is created.
  async created() {
    this.fn_hashUrl()
    if (window.setTimeoutEmployee) {
      clearTimeout(window.setTimeoutEmployee)
    }
    this.refreshData()
  },
  // Listening for the collapse event and then setting the showWorkDayChart and showDetailChart to true
  // or false depending on the collapse state.
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId == 'accordion-1') {
        this.mData.showWorkDayChart = isJustShown
      }
      if (collapseId == 'accordion-2') {
        this.mData.showDetailChart = isJustShown
      }
      if (collapseId == 'calendar') {
        this.mData.showDCalendar = isJustShown
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.doing {
  font-weight: 500;
  font-size: 22px;
  line-height: 60px;
  color: #FFFFFF;
  &--card {
    display: flex !important;
    justify-content: center;
    align-items: center;
    p {
      font-weight: 500;
      font-size: 23px;
      line-height: 60px;
    }
  }
}
::v-deep .main-card-body {
  .body-header {
    align-items: center;
    padding-left: 0;
    padding-right: 0;
  }
  .time-update {
    font-size: 15px;
    font-weight: 700;
  }
  .main-body {
    padding: 0;
    .detail-infomation {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      margin-bottom: 20px;
      &__block {
        height: 170px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        padding: 10px 15px 15px 15px;
        &.work-data {
          background: #39ABEC;
        }
        &.work-error {
          background: #F12727;
        }
        &.ontime {
          background: #1E3CD7;
        }
        &.go-late {
          background: #F79E61;
        }
        &.day-off {
          background: #FF5621;
        }
        .data {
          margin-bottom: 15px;
          position: relative;
          span {
            font-family: 'LexendDeca Regular';
            font-weight: 500;
            font-size: 42px;
            line-height: 60px;
            color: #FFFFFF;
          }
          .icon {
            position: absolute;
            top: 15px;
            right: 0px;
            [class^="icon24-"] {
              &::before {
                color: var(--white);
                font-size: 28px;
              }
            }
            [class^="isax-"] {
              &::before {
                color: var(--white);
                font-size: 28px;
              }
            }
          }
        }
        .title {
          p {
            font-family: 'LexendDeca Regular';
            color: #FFFFFF;
            font-weight: 300;
            font-size: 16px;
            line-height: 28px;
          }
        }
      }
    }
    .body-container {
      display: grid;
      grid-gap: 24px;
      grid-template-columns: 1fr 420px;
      grid-template-areas: "block__left block__aside";
      //Mobile
      // grid-template-areas: "block__aside" "block__chart__work" "block__chart__detailed" "block__request";
      .block-left {
        grid-area: block__left;
        display: grid;
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
          "block__chart__work block__chart__detailed"
          "block__request block__request";
        height: 100px;
        min-width: 0;
        .block__chart {
          height: fit-content;
          min-width: 0;
          .el-card {
            border-radius: 8px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
            .el-card__body {
              padding-top: 0;
              .card-body {
                display: grid;
                grid-template-columns: 1.5fr 1fr;
                .chart {

                }
                .detail-data {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  font-family: 'LexendDeca Regular';
                  .main-title {
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 29px;
                  }
                  .sub-title {
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 25px;
                  }
                }
              }
            }
          }
          &--work {
            grid-area: block__chart__work;
          }
          &--detailed {
            grid-area: block__chart__detailed;
          }
        }
        .block__request {
          grid-area: block__request;
          // border-radius: 8px;
          // box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
          margin-bottom: 20px;
          min-width: 0;
          .el-table {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
          }
        }
      }
      .block__aside {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
        margin-bottom: 20px;
        border-radius: 8px;
        grid-area: block__aside;
        min-width: 420px;
        padding: 20px;
        background: #fff;
        .noti--list {
          padding-top: 10px;
          border-top: 1px solid #D0D5D9;
          &.collapse-calendar {
            .noti--list__component {
              max-height: 540px;
              overflow-y: auto;
            }
          }
          .title {
            font-family: 'LexendDeca Regular';
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            color: #292D32;
            margin-bottom: 5px;
          }
          .noti--list__component {
            max-height: 500px;
            overflow-y: auto;
          }
        }
      }
    }
  }
}
::v-deep .el-card {
  .el-card__header {
    padding: 20px 20px 5px 20px;
    .clearfix {
      .title {
        font-family: 'LexendDeca Regular';
        font-weight: 400;
        font-size: 20px;
        line-height: 32px;
      }
      .toggle--action {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        font-family: 'LexendDeca Regular';
        color: #1E3CD7;
      }
    }
  }
}
::v-deep .el-card.card--calendar {
  box-shadow: none;
  border-radius: 0;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border: none;
  .el-card__header {
    padding: 0;
    padding-bottom: 10px;
  }
  .el-card__body {
    padding: 0;
    .card-body {
      padding: 0;
      .vc-weeks {
        padding: 0;
      }
      .vc-arrows-container {
        padding: 8px 0;
      }
    }
  }
}
.select-period {
  &.el-select {
    width: 260px;
  }
  ::v-deep .el-input  {
    width: 100%;
    .el-input__inner {
     width: 100%;
     background: transparent;
     border: none;
     box-shadow: none;
     font-weight: 600;
     font-size: 22px;
     line-height: 32px;
     color: #292D32;
     padding-left: 0;
     padding-right: 0;
   }
  }
  ::v-deep .el-input__suffix {
    .el-icon-arrow-up:before {
      font-weight: 900;
      font-size: 18px;
    }
  }
}
.dot {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 5px;
  &--enough {
    background: #39ABEC;
  }
  &--error {
    background: #F12727;
  }
  &--remaning {
    background: #D0D5D9;
  }
  &--golate {
    background: #F79E61;
  }
  &--dayoff {
    background: #FF5621;
  }
  &--ontime {
    background: #1E3CD7;
  }
  &--others {
    background: #D0D5D9;
  }
}
@media (max-width: 1640px) {
  .main-card-body {
    .main-body {
      .detail-infomation {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }
  }
}
@media (max-width: 1390px) {
  .main-card-body {
    .main-body {
      .detail-infomation {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
}

@media (max-width: 1200px) {
  .main-card-body {
    .main-body {
      .detail-infomation {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
@media (max-width: 950px) {
  .main-card-body {
    .main-body {
      .detail-infomation {
        grid-template-columns: 1fr;
      }
      .body-container {
        grid-template-columns: 1fr;
        grid-template-areas:
          "block__left"
          "block__aside";
        .block-left {
          grid-template-columns: 1fr;
          grid-template-areas:
            "block__chart__work"
            "block__chart__detailed"
            "block__request";
          height: auto;
          .block__request {
            ::v-deep .el-card__body {
              overflow-x: auto;
            }
            ::v-deep .el-table--request {
              min-width: 650px;
            }
          }
        }
        .block__aside {
          min-width: 0;
        }
      }
    }
  }
}
@media (max-width: 547px) {
  .main-card-body {
    .body-header {
      flex-wrap: wrap;
      gap: 10px;
    }
    .main-body {
      .body-container {
        .block-left {
          .block__chart {
            .el-card {
              .el-card__body {
                .card-body {
                  grid-template-columns: 1fr;
                }
              }
            }
          }
        }
      }
    }
  }
  .select-period {
    &.el-select {
      width: 100%;
    }
  }
}
</style>
